export class SnapshotCoverage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "availability",
            "baseName": "availability",
            "type": "SnapshotCoverageAvailability",
            "format": ""
        },
        {
            "name": "objectStore",
            "baseName": "objectStore",
            "type": "ObjectStoreCoverageBreakdown",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SnapshotCoverage.attributeTypeMap;
    }
    constructor() {
    }
}
